import React from "react";
import { Typography, Box, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CategoryList from "./CategoryList";
import { useTranslation } from "react-i18next";

export default function CategoryGroup({
	categoriesType,
	data,
	transactions,
	selectedType,
	setSelectedType,
	selectedCategory,
	setSelectedCategory,
	selectedSubcategory,
	setSelectedSubcategory,
}) {
	const theme = useTheme();
	const { t } = useTranslation();
	const userCurrency = localStorage.getItem("userCurrency");

	const getTransactionsForCategoryGroup = (groupId) => {
		const transactionsForCategoryGroup = transactions.filter(
			(transaction) => transaction.categoryId === groupId
		);
		return transactionsForCategoryGroup;
	};

	const getAllCategoriesAmount = () => {
		const allCategoriesAmount = transactions.reduce(
			(sum, item) =>
				item.includeInAnalysis
					? sum + item.amount * item.exchangeRate
					: sum,
			0
		);
		return parseFloat(allCategoriesAmount.toFixed(2));
	};

	const getNoCategoryAmount = () => {
		const noCategoryAmount = transactions.reduce((sum, item) => {
			if (!item.categoryId && item.includeInAnalysis) {
				return sum + item.amount * item.exchangeRate;
			}
			return sum;
		}, 0);
		return parseFloat(noCategoryAmount.toFixed(2));
	};

	const getAmountColor = (amount) => {
		return amount > 0
			? theme.palette.values.positive
			: amount < 0
				? theme.palette.values.negative
				: "none";
	};

	const handleClickCategoryType = () => {
		if (selectedType === categoriesType) {
			setSelectedType(null);
			setSelectedCategory(null);
			setSelectedSubcategory(null);
		} else {
			setSelectedType(categoriesType);
			setSelectedCategory(null);
			setSelectedSubcategory(null);
		}
	};

	const handlePreventTypeClick = (event) => {
		event.stopPropagation();
	};

	const mainBoxStyles = {
		mb: 2,
		mr: 2,
		width: "100%",
		borderRadius: "20px",
		flex: 1,
		backgroundColor: theme.palette.background.default,
		"&:has(:hover)": {
			cursor: "pointer",
			borderRadius: "20px",
			backgroundColor:
				theme.components.MuiButton.styleOverrides.textPrimary,
		},
		"&:has(> .inner:hover)": {
			cursor: "default",
			backgroundColor: theme.palette.background.default,
		},
	};

	const categoriesTypeBoxStyles = {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		mx: 3,
		my: 1,
	};

	const categoryListBoxStyles = {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
		mb: 1,
		mx: 1,
	};

	const noCateogoryBoxStyles = {
		display: "flex",
		mx: 1,
		mb: 1,
		p: 1,
		bgcolor: theme.palette.background.paper,
		borderRadius: "10px",
		width: "100%",
		justifyContent: "space-between",
	};

	return (
		<Box sx={mainBoxStyles} onClick={handleClickCategoryType}>
			<Box sx={categoriesTypeBoxStyles}>
				<Box>
					<Typography
						variant="h6"
						gutterBottom
						sx={{ textAlign: "center", mt: 1, mb: 0 }}
					>
						{t(categoriesType)}
					</Typography>
				</Box>
				<Box>
					<ListItemText
						primaryTypographyProps={{
							sx: {
								mt: 1,
								mb: 0,
								fontWeight: "bold",
								color: getAmountColor(getAllCategoriesAmount()),
							},
						}}
						primary={`${getAllCategoriesAmount().toFixed(2).toLocaleString()} ${userCurrency}`}
					/>
				</Box>
			</Box>
			<Box
				sx={categoryListBoxStyles}
				className="inner"
				onClick={(event) => handlePreventTypeClick(event)}
			>
				{data.map((categoryGroup) => (
					<CategoryList
						key={categoryGroup._id}
						categoryGroup={categoryGroup}
						transactions={getTransactionsForCategoryGroup(
							categoryGroup._id
						)}
						selectedCategory={selectedCategory}
						setSelectedCategory={setSelectedCategory}
						selectedSubcategory={selectedSubcategory}
						setSelectedSubcategory={setSelectedSubcategory}
					/>
				))}
				{getNoCategoryAmount() !== 0 && (
					<Box sx={noCateogoryBoxStyles}>
						<Typography sx={{ mx: 2, fontWeight: "bold" }}>
							{t("noCategory")}
						</Typography>

						<Typography
							sx={{
								mx: 2,
								fontWeight: "bold",
								color: getAmountColor(getNoCategoryAmount()),
							}}
						>
							{getNoCategoryAmount()} {userCurrency}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
}
